<div class="top-section">
    <div class="flex items-center">
        <app-svg name="hamburger" class="common-hamburger" (click)="ss.toggleSidebar()" role="button"
            [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>
        <h4 class="heading mb-0">{{ ss.t('common_messages') }}</h4>
    </div>
    <div class="flex items-center gap-6">
        <app-svg name="plus" class="filter-icon" role="button" (click)="openNewMessagePicker()"
            *ngIf="!cc.isNarrowScreen()" [color]="ss.theme().color8" [width]="'15px'" [height]="'15px'"
            style="margin-inline-end: -6px;" [title]="ss.t('messages_newChat')"></app-svg>
        <app-notification [iconColor]="cc.isNarrowScreen() ? ss.theme().color12 : null"></app-notification>
    </div>
</div>

<div class="body-section" *ngIf="sortedSetups().length > 0">
    <div class="message-list">
        <div class="message-item flex items-center ri-bb-1 cursor-pointer" [class.unread]="isUnread(setup)"
            *ngFor="let setup of sortedSetups(); trackBy: trackBySetupId" (click)="onMessageTileClick(setup)">
            <!-- Avatar (entity icon / group icon / MeUserAvatar) -->
            @switch (mds.getAvatarType({ setup: setup })) {
            @case ('user-avatar') {
            <app-me-user-avatar [email]="mds.getOtherPersonEmail({ setup: setup })" [radius]="10"
                class="message-avatar"></app-me-user-avatar>
            }
            @case ('entity-icon') {
            <div class="message-avatar-icon">
                <app-svg [name]="mds.getEntityIconName({ setup: setup })!" [color]="ss.theme().color12" width="11"
                    height="11"></app-svg>
            </div>
            }
            @case ('group-icon') {
            <div class="message-avatar-icon">
                <app-svg name="users" [color]="ss.theme().color12" width="12" height="12"></app-svg>
            </div>
            }
            }
            <!-- Message Info -->
            <div class="message-info">
                <div class="message-info-top">
                    <p class="message-name">{{ mds.getTitle({ setup: setup }) }}</p>
                    <div class="message-meta">
                        @if (isMuted(setup)) {
                        <app-svg name="bell" [color]="ss.theme().color7" width="12" height="12"
                            class="mute-icon"></app-svg>
                        }
                        <span class="message-time" *ngIf="setup.lastMessageAt">
                            {{ setup.lastMessageAt | smartTimeDiff : undefined : 'short-weeks' }}
                        </span>
                    </div>
                </div>
                <!-- Subtitle (entity setup/action only, not singles/person) -->
                @if (mds.getListSubtitle({ setup: setup })) {
                <span class="message-subtitle">{{ mds.getListSubtitle({ setup: setup }) }}</span>
                }
                <!-- Draft preview (priority) or last message preview -->
                @if (mds.getDraftPreview({ setup: setup }); as draftText) {
                <div class="message-preview-row">
                    <p class="message-draft-preview">
                        <span class="draft-label">Draft: </span>{{ draftText }}
                    </p>
                </div>
                } @else {
                <div class="message-preview-row">
                    <p class="message-preview">{{ mds.getLastMessagePreview({ setup: setup }) }}</p>
                </div>
                }
            </div>
        </div>
    </div>
</div>

<div class="body-section empty-state" *ngIf="sortedSetups().length === 0">
    <app-no-result-block [imagePlaceholder]="'messagePlaceholder'" [messageTextClass]="'text-16-500 color-7'"
        [message]="ss.t('supportChat_emptyScreenContent')" [showQuickGuide]="false">
    </app-no-result-block>
</div>

<!-- Bottom Bar with projected FAB -->
<app-mobile-bottom-bar>
    <button class="mobile-fab" (click)="openNewMessagePicker()" [attr.aria-label]="ss.t('aria_newChat')">
        <app-svg name="messageBottom" [color]="ss.theme().color12" width="18" height="18"></app-svg>
    </button>
</app-mobile-bottom-bar>

<!-- Side Panel Overlay (same pattern as meo-page) -->
@if (selectedSetupId()) {
<div class="message-overlay-backdrop" (click)="goBackToList()"></div>
<div class="message-panel-container">
    <app-message-view [setupId]="selectedSetupId()!"
        [entityId]="selectedSetup()?.entityId ?? undefined"
        [entityCollection]="selectedSetup()?.entityCollection ?? undefined"
        (goBack)="goBackToList()">
    </app-message-view>
</div>
}